var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner search",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SelectOrderNumber"),
        width: "1250px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.beforeCloseHandler
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c("search-item", {
            attrs: {
              "config-module": "100300",
              reset: true,
              "show-simple": false,
              "expand-adv": true,
              "col-settings": { span: 8 },
              "custom-search-items": _vm.customSearchItems,
              "grid-config-module": "1003001"
            },
            on: {
              advSearchItemCallBack: _vm.toQuery,
              perConfigChange: function(value) {
                _vm.perConfigName = value
              },
              refreshGrid: function() {
                _vm.gridRefreshId += 1
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { "min-height": "300px" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData,
              "per-config-name": _vm.perConfigName,
              "refresh-id": _vm.gridRefreshId,
              "config-module": "1310011"
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "justify-content": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { no: "add", type: "primary" }, on: { click: _vm.add } },
            [_vm._v(_vm._s(_vm.$t("Message.Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }